import {
  getUrl,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class GetPresignedDownloadURLForQuestionOptionsTemplateRPC implements
  LeoRPC<GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Request, GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Response, GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Errors.Errors>
{
  abstract execute(
    request: GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Request
  ): Promise<LeoRPCResult<GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Response, GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Errors.Errors>>;
}

export namespace GetPresignedDownloadURLForQuestionOptionsTemplateRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {}

  export class Request implements LeoRPCRequest {
    readonly isGetPresignedDownloadURLForQuestionOptionsTemplateRPCRequest: boolean = true;
    toDTO(): RequestDTO {
      return {}
    }
  }

  Request.prototype.toString = function toString(): string {
    return `GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Request`;
  };

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    documentURL: string;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetPresignedDownloadURLForQuestionOptionsTemplateResponse: boolean = true;
  
    readonly documentURL: URL;
  
  
    constructor(
    documentURL: URL
    ) {
      this.documentURL = documentURL;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const documentURL = getUrl(dto, "documentURL", InvalidResponseDocumentUrlError);
      return new Response(
        documentURL
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          documentURL: this.documentURL.toString()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetPresignedDownloadURLForQuestionOptionsTemplate(documentURL='${this.documentURL}')`;
  };
  


  export namespace Errors {

    export type Errors = any;
    export type ErrorsDTO = any;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}


export class InvalidResponseDocumentUrlError extends GetPresignedDownloadURLForQuestionOptionsTemplateRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDocumentUrlError";
  }
}

